module.exports = __webpack_public_path__ + "img/v11.3ade469c.png";